import { useFormik } from "formik";
import { useTranslation } from "next-i18next";
import * as yup from "yup";
import { RequestedPortalData } from "./requested-portal-model";

/**
 * Manages form data for the requested portal step.
 * @param onNext a call back that signals submission
 * @returns a formik instance
 */
export function useRequestedPortalFormik(
  onNext: (data: RequestedPortalData) => void
) {
  const { t } = useTranslation();
  const other = t("request_access:more_information.other");
  const messageRequired = t("common:common.required");

  const validationSchema = yup.object().shape({
    cargillBusiness: yup.string().required(messageRequired),
    appRefName: yup.string().required(messageRequired),

    country: yup.string().when("cargillBusiness", {
      is: other,
      then: yup.string().notRequired(),
      otherwise: yup.string().required(messageRequired),
    }),

    requestReason: yup.string().required(messageRequired),

    accessReason: yup.string().when("requestReason", {
      is: other,
      then: yup.string().required(messageRequired),
      otherwise: yup.string().notRequired(),
    }),
  });

  const formik = useFormik<RequestedPortalData>({
    initialValues: {
      cargillBusiness: "",
      appRefName: "",
      country: "",
      requestReason: "",
      accessReason: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onNext(values);
    },
  });

  return formik;
}